module.exports = __webpack_public_path__ + "assets/img/warrior-name-842cbc07.png";